export default "__VITE_ASSET__BiOVLXAq__"